/** Domestic sector labels — same IATA-style codes used by Nepali OTAs (eSewa, airlines). */

/** Shown when /api/flights/sectors is down or returns empty (prod API outages). */
export const NEPAL_FALLBACK_SECTORS = [
	{ SectorCode: 'KTM', SectorName: 'Kathmandu (Tribhuvan)' },
	{ SectorCode: 'PKR', SectorName: 'Pokhara' },
	{ SectorCode: 'LUA', SectorName: 'Lukla' },
	{ SectorCode: 'BHR', SectorName: 'Bharatpur' },
	{ SectorCode: 'BWA', SectorName: 'Bhairahawa (Siddharthanagar)' },
	{ SectorCode: 'BDP', SectorName: 'Bhadrapur' },
	{ SectorCode: 'BIR', SectorName: 'Biratnagar' },
	{ SectorCode: 'DOP', SectorName: 'Dolpa' },
	{ SectorCode: 'JMO', SectorName: 'Jomsom' },
	{ SectorCode: 'KEP', SectorName: 'Nepalgunj' },
	{ SectorCode: 'RJB', SectorName: 'Rajbiraj' },
	{ SectorCode: 'RUK', SectorName: 'Rukum' },
	{ SectorCode: 'SIF', SectorName: 'Simara' },
	{ SectorCode: 'TMI', SectorName: 'Tumlingtar' },
];

export const POPULAR_NEPAL_FLIGHT_ROUTES = [
	{ label: 'Kathmandu ↔ Pokhara', from: 'KTM', to: 'PKR' },
	{ label: 'Kathmandu → Lukla', from: 'KTM', to: 'LUA' },
	{ label: 'Kathmandu → Bharatpur', from: 'KTM', to: 'BHR' },
	{ label: 'Pokhara → Jomsom', from: 'PKR', to: 'JMO' },
];

export function sectorDropdownOptions(sectors, { excludeCode } = {}) {
	return (sectors || [])
		.filter((s) => s.SectorCode && s.SectorCode !== excludeCode)
		.map((sector) => ({
			key: sector.SectorCode,
			value: sector.SectorCode,
			text: formatSectorLabel(sector),
		}));
}

export function formatSectorLabel(sector) {
	if (!sector) return '';
	const code = sector.SectorCode || '';
	const name = sector.SectorName || code;
	if (!code) return name;
	if (name.toUpperCase().includes(code)) return name;
	return `${name} (${code})`;
}

export function sectorDisplayName(sectors, code) {
	if (!code) return '';
	const match = (sectors || []).find((s) => s.SectorCode === code);
	return match ? formatSectorLabel(match) : code;
}

function normalizeSectorRecord(item) {
	if (!item || typeof item !== 'object') return null;
	const code = (
		item.SectorCode ||
		item.sector_code ||
		item.Code ||
		item.code ||
		item.strSectorCode ||
		''
	)
		.toString()
		.trim()
		.toUpperCase();
	if (!code) return null;
	const name = (
		item.SectorName ||
		item.sector_name ||
		item.Name ||
		item.name ||
		code
	)
		.toString()
		.trim();
	return { SectorCode: code, SectorName: name };
}

export function normalizeSectorList(raw) {
	const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
	return list.map(normalizeSectorRecord).filter(Boolean);
}

/** API list wins; fallback fills gaps so From/To always have Nepal sectors. */
export function mergeSectorsWithFallback(apiSectors) {
	const byCode = new Map();
	NEPAL_FALLBACK_SECTORS.forEach((s) => byCode.set(s.SectorCode, { ...s }));
	normalizeSectorList(apiSectors).forEach((s) => byCode.set(s.SectorCode, s));
	return Array.from(byCode.values()).sort((a, b) =>
		a.SectorName.localeCompare(b.SectorName)
	);
}

export function resolveDefaultSectors(sectors, details = {}) {
	const from = details.strSectorFrom;
	const to = details.strSectorTo;
	if (from && to) {
		return { strSectorFrom: from, strSectorTo: to };
	}
	const codes = (sectors || []).map((s) => s.SectorCode);
	const pick = (code) => (codes.includes(code) ? code : '');
	const strSectorFrom = from || pick('KTM') || codes[0] || '';
	let strSectorTo = to || pick('PKR');
	if (!strSectorTo || strSectorTo === strSectorFrom) {
		strSectorTo = codes.find((c) => c !== strSectorFrom) || '';
	}
	return { strSectorFrom, strSectorTo };
}
